import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import SyncIcon from "@mui/icons-material/Sync";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
  DataGrid,
} from "@mui/x-data-grid";

import { useState } from "react";
import { useEffect } from "react";
import { AddErrorLog, Delete, Get, Post, Put } from "../../Common/WebRequest";
import DeleteConfirmation from "../../components/DeleteConfirmation";

import { useNavigate } from "react-router-dom";
import { slice, getStorageItem } from "../../Common/Utility";
import { Typography } from "@mui/material";

function EditToolbar(props) {
  const { setRegionsData, setRowModesModel, isAdmin } = props;
  let navigate = useNavigate();
  const handleAddClick = () => {
    const id = 0;
    setRegionsData((oldRows) => [
      ...oldRows,
      { id, regionName: "", isNew: true },
    ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "regionName" },
    }));
  };

  function handleRefresh() {
    navigate(0);
  }

  function handleSaveClicks() {
    console.log("Save Click ==>");
  }

  return (
    <GridToolbarContainer>
      <Button
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddClick}
        disabled={!isAdmin}
      >
        Neu
      </Button>

      <GridToolbarColumnsButton />
      <GridToolbarFilterButton field="regionName" />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        csvOptions={{
          fileName: "Regionen",
          delimiter: ";",
          utf8WithBom: true,
        }}
      />

      <GridToolbarQuickFilter />
      <Button color="primary" startIcon={<SyncIcon />} onClick={handleRefresh}>
        Refresh
      </Button>
    </GridToolbarContainer>
  );
}

EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
  setRegionsData: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

export default function RegionsGrid() {
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [regionsData, setRegionsData] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [reload, setReload] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    (async () => {
      const admin = await getStorageItem("login", "isAdmin");
      setIsAdmin(!!admin);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      let res = await Get("region");

      if (res.isSuccess) setRegionsData(res.result);
      else {
        setError(res.Status + "/" + res.Error);

        // await AddErrorLog(err);
      }
    })();
  }, [reload]);

  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);

  const showDeleteModal = (type, id) => {
    setType(type);
    setId(id);

    setDeleteMessage(
      `Möchten Sie „${
        regionsData.find((x) => x.id === id).regionName
      }“ wirklich löschen?`
    );

    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleRowEditStart = (params, event) => {
    if (!isAdmin) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;

    console.log("Cell lost focus / exit  edit ==> ", params, event);
    //console.log("event.target.value :: ******** ", params, event.target.value);
  };

  const handleEditClick = (id) => () => {
    setSuccessMsg("");
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "regionName" },
    });
    console.log("## Edit clicked -- id=", id);
  };
  // #### save #######################

  async function DoSaveApi(newRow, updatedRow) {
    let res = "";
    let isSuccess = false;
    setError("");
    setSuccessMsg("");
    setRegionsData(
      regionsData.map((row) => (row.id === newRow.id ? updatedRow : row))
    );
    if (updatedRow.id === 0) {
      updatedRow.isNew = true;
      res = await Post("region", updatedRow);
      isSuccess = res.isSuccess;
    } else {
      res = await Put("region", updatedRow.id, newRow);

      isSuccess = res.isSuccess;
    }
    if (isSuccess) {
      setReload(!reload);
      updatedRow.isNew
        ? setSuccessMsg("Die neue Region wurde hinzugefügt.")
        : setSuccessMsg("Die Region wurde aktualisiert.");
    } else {
      console.log("Error: ################################### ", res.Error);
      setError(res.Status + "/" + res.Error + "/" + res.ErrorDetail);
      setReload(!reload);
      await AddErrorLog(error);
    }
  }
  const handleDeleteClick = (id) => () => {
    showDeleteModal("", id);
    //setRegionsData(regionsData.filter((row) => row.id !== id));
  };

  async function doDeleteApi() {
    setError("");
    setSuccessMsg("");
    let res = await Delete("region", id);
    if (!res.isSuccess) {
      setError(res.Status + "/" + res.Error + "/" + res.ErrorDetail);
      console.log(
        "Error:",
        res.Status + "/" + res.Error + "/" + res.ErrorDetail
      );
    } else {
      setSuccessMsg("Die Region wurde erfolgreich gelöscht.");
      setReload(!reload);
    }
  }
  const handleAfterDeleteClick = () => {
    setDisplayConfirmationModal(false);
    doDeleteApi();
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = regionsData.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRegionsData(regionsData.filter((row) => row.id !== id));
    }
  };
  const handleError = (err) => {
    console.log("handleError");

    console.log(err);
    setError(err.message);
  };
  const handleSaveClick = (id) => async (event) => {
    event.stopPropagation();
    // await apiRef.current.stopRowEditMode({ id });
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    console.log("Save click ===> ", id);
  };
  async function processRowUpdate(newRow) {
    console.log("new region:", newRow);
    const updatedRow = { ...newRow, isNew: false };
    DoSaveApi(newRow, updatedRow);
    /* setRegionsData(
      regionsData.map((region) => {
        if (region.id === newRow.id) return newRow;
        return region;
      })
    );*/

    return updatedRow;
  }

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 50, editable: false },
    {
      field: "regionName",
      headerName: "Region *",
      type: "text",
      editable: isAdmin,
      flex: 1,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={handleSaveClick(id)}
              disabled={!isAdmin}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
              disabled={!isAdmin}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
        ];
      },
    },
  ];

  return (
    <Box
      sx={{
        height: 800,
        width: "95%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      <br></br>
      <h2>Regionen</h2>
      <br></br>
      {error.length > 0 && (
        <div className="alert alert-danger" role="alert">
          {slice(error, 200, "...")}
        </div>
      )}

      {error.length === 0 && successMsg.length > 0 && (
        <div className="alert alert-success" role="alert">
          {slice(successMsg, 100, "...")}
        </div>
      )}
      <br></br>
      <DataGrid
        rowSelection={false}
        density="compact"
        hideFooterPagination
        rows={regionsData}
        columns={columns}
        editMode="row"
        // rowsPerPageOptions={5}
        // initialState={{
        //   pagination: {
        //     paginationModel: { pageSize: 30, page: 5 },
        //   },
        // }}
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        //onCellEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleError}
        slots={{
          toolbar: EditToolbar,
        }}
        slotProps={{
          toolbar: { setRegionsData, setRowModesModel, isAdmin },
        }}
      />

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleAfterDeleteClick}
        hideModal={hideConfirmationModal}
        type={type}
        id={id}
        message={deleteMessage}
      />
    </Box>
  );
}
